"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _html5Qrcode = require("html5-qrcode");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'QRCodeScanner',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    autoStart: {
      type: Boolean,
      default: true
    },
    rearCamera: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      visible: false,
      scanner: null,
      cameras: [],
      currentCameraIndex: 0,
      scanning: false,
      scanHandled: false,
      errorMessage: '',
      closing: false,
      starting: false,
      /**
       * 当前使用的 cameraId
       */
      currentCameraId: null
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (!val) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return this.open();
              case 1:
                _context.n = 4;
                break;
              case 2:
                _context.n = 3;
                return this.stopScanner();
              case 3:
                this.visible = false;
              case 4:
                return _context.a(2);
            }
          }, _callee, this);
        }));
        function handler(_x) {
          return _handler.apply(this, arguments);
        }
        return handler;
      }()
    }
  },
  methods: {
    // =========================================================
    // 工具
    // =========================================================
    sleep: function sleep(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    },
    // =========================================================
    // iOS 判断
    // =========================================================
    isIOS: function isIOS() {
      return /iPad|iPhone|iPod/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    },
    // =========================================================
    // 打开
    // =========================================================
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!this.visible) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.visible = true;
              this.scanHandled = false;
              this.errorMessage = '';
              this.closing = false;
              this.starting = false;
              this.cameras = [];
              this.currentCameraIndex = 0;
              this.currentCameraId = null;
              if (this.autoStart) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return this.$nextTick();
            case 3:
              _context2.n = 4;
              return this.sleep(150);
            case 4:
              if (this.visible) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2);
            case 5:
              _context2.n = 6;
              return this.startScanner();
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function open() {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    // =========================================================
    // 启动扫码
    // =========================================================
    startScanner: function () {
      var _startScanner = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(this.scanning || this.starting)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              this.starting = true;
              _context3.p = 2;
              this.errorMessage = '';

              /**
               * =========================
               * HTTPS
               * =========================
               */
              if (window.isSecureContext) {
                _context3.n = 3;
                break;
              }
              throw new Error('HTTPS_REQUIRED');
            case 3:
              if (!(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia)) {
                _context3.n = 4;
                break;
              }
              throw new Error('MEDIA_NOT_SUPPORTED');
            case 4:
              _context3.n = 5;
              return this.stopScanner();
            case 5:
              /**
               * =========================
               * 创建 Html5Qrcode
               * =========================
               */

              this.scanner = new _html5Qrcode.Html5Qrcode('qr-reader');

              /**
               * =====================================================
               * iOS
               * =====================================================
               *
               * iOS 不走第一次 facingMode。
               *
               * 先获取权限：
               *
               * getUserMedia
               *
               * 然后：
               *
               * getCameras
               *
               * 最后：
               *
               * scanner.start(cameraId)
               *
               * 这样第一次启动和“切换摄像头”走的是同一种方式。
               */
              if (!this.isIOS()) {
                _context3.n = 7;
                break;
              }
              _context3.n = 6;
              return this.startIOS();
            case 6:
              _context3.n = 10;
              break;
            case 7:
              if (!this.rearCamera) {
                _context3.n = 9;
                break;
              }
              _context3.n = 8;
              return this.startWithFacingMode();
            case 8:
              _context3.n = 10;
              break;
            case 9:
              _context3.n = 10;
              return this.startWithFrontCamera();
            case 10:
              /**
               * =========================
               * 启动成功
               * =========================
               */

              this.scanning = true;

              /**
               * =========================
               * 修复 video
               * =========================
               */
              _context3.n = 11;
              return this.fixVideo();
            case 11:
              if (!(!this.cameras || this.cameras.length === 0)) {
                _context3.n = 15;
                break;
              }
              _context3.p = 12;
              _context3.n = 13;
              return _html5Qrcode.Html5Qrcode.getCameras();
            case 13:
              this.cameras = _context3.v;
              _context3.n = 15;
              break;
            case 14:
              _context3.p = 14;
              _t = _context3.v;
              console.warn('获取摄像头列表失败:', _t);
            case 15:
              _context3.n = 18;
              break;
            case 16:
              _context3.p = 16;
              _t2 = _context3.v;
              console.error('启动扫码失败:', _t2);
              _context3.n = 17;
              return this.stopScanner();
            case 17:
              this.handleCameraError(_t2);
            case 18:
              _context3.p = 18;
              this.starting = false;
              return _context3.f(18);
            case 19:
              return _context3.a(2);
          }
        }, _callee3, this, [[12, 14], [2, 16, 18, 19]]);
      }));
      function startScanner() {
        return _startScanner.apply(this, arguments);
      }
      return startScanner;
    }(),
    // =========================================================
    // iOS 专用启动
    // =========================================================
    startIOS: function () {
      var _startIOS = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var permissionStream, cameras, camera, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              /**
               * =====================================================
               * 第一步：先主动获取摄像头权限
               * =====================================================
               *
               * 目的不是拿这个 stream 来扫码。
               *
               * 而是让 Safari：
               *
               * 1. 完成摄像头授权
               * 2. 解锁 camera label
               * 3. 让 enumerateDevices / getCameras
               *    可以返回真实 camera 信息
               */
              permissionStream = null;
              _context4.p = 1;
              _context4.n = 2;
              return navigator.mediaDevices.getUserMedia({
                video: true,
                audio: false
              });
            case 2:
              permissionStream = _context4.v;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              throw _t3;
            case 4:
              _context4.p = 4;
              /**
               * 这个 stream 只是用来获取权限。
               *
               * 后面真正的扫码由 html5-qrcode
               * 重新打开摄像头。
               */

              if (permissionStream) {
                permissionStream.getTracks().forEach(function (track) {
                  try {
                    track.stop();
                  } catch (e) {
                    console.warn(e);
                  }
                });
              }
              return _context4.f(4);
            case 5:
              _context4.n = 6;
              return this.sleep(100);
            case 6:
              _context4.n = 7;
              return _html5Qrcode.Html5Qrcode.getCameras();
            case 7:
              cameras = _context4.v;
              if (!(!cameras || cameras.length === 0)) {
                _context4.n = 8;
                break;
              }
              throw new Error('没有找到摄像头');
            case 8:
              this.cameras = cameras;

              /**
               * =====================================================
               * 第三步：寻找后置摄像头
               * =====================================================
               */

              if (this.rearCamera) {
                camera = this.findRearCamera(cameras);
              } else {
                camera = this.findFrontCamera(cameras);
              }

              /**
               * 如果没有找到，
               * 至少使用第一个。
               */

              if (!camera) {
                camera = cameras[0];
              }
              this.currentCameraIndex = cameras.findIndex(function (item) {
                return item.id === camera.id;
              });
              if (this.currentCameraIndex < 0) {
                this.currentCameraIndex = 0;
              }
              this.currentCameraId = camera.id;
              console.log('iOS 选择摄像头:', camera);

              /**
               * =====================================================
               * 第四步：
               *
               * 直接使用 cameraId 启动
               * =====================================================
               */
              _context4.n = 9;
              return this.startWithCamera(camera.id);
            case 9:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function startIOS() {
        return _startIOS.apply(this, arguments);
      }
      return startIOS;
    }(),
    // =========================================================
    // 寻找后置摄像头
    // =========================================================
    findRearCamera: function findRearCamera(cameras) {
      /**
       * Safari 授权之后
       * label 通常会变得可用。
       */

      var rear = cameras.find(function (camera) {
        var label = (camera.label || '').toLowerCase();
        return label.includes('back') || label.includes('rear') || label.includes('environment') || label.includes('后置') || label.includes('后摄');
      });
      if (rear) {
        return rear;
      }

      /**
       * iPhone 如果 label 不可靠，
       * 通常至少有多个 camera。
       *
       * 这里不要强行认为最后一个
       * 一定是后置。
       *
       * 但作为 fallback 可以使用最后一个。
       */

      if (cameras.length > 1) {
        return cameras[cameras.length - 1];
      }
      return cameras[0];
    },
    // =========================================================
    // 寻找前置
    // =========================================================
    findFrontCamera: function findFrontCamera(cameras) {
      var front = cameras.find(function (camera) {
        var label = (camera.label || '').toLowerCase();
        return label.includes('front') || label.includes('user') || label.includes('前置') || label.includes('前摄');
      });
      if (front) {
        return front;
      }
      return cameras[0];
    },
    // =========================================================
    // facingMode
    // =========================================================
    startWithFacingMode: function () {
      var _startWithFacingMode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.scanner.start({
                facingMode: 'environment'
              }, this.getScannerConfig(), this.handleDecode, this.handleScanError);
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function startWithFacingMode() {
        return _startWithFacingMode.apply(this, arguments);
      }
      return startWithFacingMode;
    }(),
    // =========================================================
    // 前置
    // =========================================================
    startWithFrontCamera: function () {
      var _startWithFrontCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return this.scanner.start({
                facingMode: 'user'
              }, this.getScannerConfig(), this.handleDecode, this.handleScanError);
            case 1:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function startWithFrontCamera() {
        return _startWithFrontCamera.apply(this, arguments);
      }
      return startWithFrontCamera;
    }(),
    // =========================================================
    // cameraId
    // =========================================================
    startWithCamera: function () {
      var _startWithCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(cameraId) {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              this.currentCameraId = cameraId;
              _context7.n = 1;
              return this.scanner.start(cameraId, this.getScannerConfig(), this.handleDecode, this.handleScanError);
            case 1:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function startWithCamera(_x2) {
        return _startWithCamera.apply(this, arguments);
      }
      return startWithCamera;
    }(),
    // =========================================================
    // 扫码配置
    // =========================================================
    getScannerConfig: function getScannerConfig() {
      return {
        fps: 10,
        qrbox: {
          width: 260,
          height: 260
        },
        aspectRatio: 1,
        disableFlip: false
      };
    },
    // =========================================================
    // video 修复
    // =========================================================
    fixVideo: function () {
      var _fixVideo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var video, i, _t4, _t5;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              /**
               * Android 和 iOS 都可以执行。
               *
               * 但是 iOS 特别重要。
               */
              video = null;
              /**
               * 等待 html5-qrcode 创建 video
               */
              i = 0;
            case 1:
              if (!(i < 40)) {
                _context8.n = 4;
                break;
              }
              video = document.querySelector('#qr-reader video');
              if (!video) {
                _context8.n = 2;
                break;
              }
              return _context8.a(3, 4);
            case 2:
              _context8.n = 3;
              return this.sleep(50);
            case 3:
              i++;
              _context8.n = 1;
              break;
            case 4:
              if (video) {
                _context8.n = 5;
                break;
              }
              console.warn('没有找到 html5-qrcode video');
              return _context8.a(2);
            case 5:
              /**
               * =========================
               * iOS video 属性
               * =========================
               */

              video.setAttribute('playsinline', 'true');
              video.setAttribute('webkit-playsinline', 'true');
              video.setAttribute('autoplay', 'true');
              video.playsInline = true;
              video.muted = true;
              video.defaultMuted = true;

              /**
               * =========================
               * 主动播放
               * =========================
               */
              _context8.p = 6;
              if (!(video.paused || video.readyState < 2)) {
                _context8.n = 7;
                break;
              }
              _context8.n = 7;
              return video.play();
            case 7:
              _context8.n = 12;
              break;
            case 8:
              _context8.p = 8;
              _t4 = _context8.v;
              console.warn('video.play() 第一次失败:', _t4);

              /**
               * 再尝试一次
               */
              _context8.n = 9;
              return this.sleep(300);
            case 9:
              _context8.p = 9;
              if (!video.paused) {
                _context8.n = 10;
                break;
              }
              _context8.n = 10;
              return video.play();
            case 10:
              _context8.n = 12;
              break;
            case 11:
              _context8.p = 11;
              _t5 = _context8.v;
              console.warn('video.play() 第二次失败:', _t5);
            case 12:
              /**
               * =========================
               * loadedmetadata
               * =========================
               */

              if (video.readyState < 2) {
                video.addEventListener('loadedmetadata', function () {
                  if (video && video.paused) {
                    video.play().catch(function (error) {
                      console.warn('loadedmetadata play 失败:', error);
                    });
                  }
                }, {
                  once: true
                });
              }
            case 13:
              return _context8.a(2);
          }
        }, _callee8, this, [[9, 11], [6, 8]]);
      }));
      function fixVideo() {
        return _fixVideo.apply(this, arguments);
      }
      return fixVideo;
    }(),
    // =========================================================
    // 找当前摄像头
    // =========================================================
    findCurrentCameraIndex: function findCurrentCameraIndex() {
      var _this = this;
      if (!this.cameras || this.cameras.length === 0) {
        return 0;
      }
      if (this.currentCameraId) {
        var index = this.cameras.findIndex(function (camera) {
          return camera.id === _this.currentCameraId;
        });
        if (index >= 0) {
          return index;
        }
      }
      return 0;
    },
    // =========================================================
    // 切换摄像头
    // =========================================================
    switchCamera: function () {
      var _switchCamera = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var camera, _t6, _t7;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              if (!(!this.cameras || this.cameras.length < 2)) {
                _context9.n = 1;
                break;
              }
              this.$message.warning('当前设备没有多个摄像头');
              return _context9.a(2);
            case 1:
              if (!this.starting) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2);
            case 2:
              this.starting = true;
              _context9.p = 3;
              this.scanHandled = false;
              this.scanning = false;

              /**
               * =========================
               * 停止
               * =========================
               */
              if (!this.scanner) {
                _context9.n = 7;
                break;
              }
              _context9.p = 4;
              _context9.n = 5;
              return this.scanner.stop();
            case 5:
              _context9.n = 7;
              break;
            case 6:
              _context9.p = 6;
              _t6 = _context9.v;
              console.warn('停止摄像头失败:', _t6);
            case 7:
              /**
               * =========================
               * 下一个
               * =========================
               */

              this.currentCameraIndex = (this.currentCameraIndex + 1) % this.cameras.length;
              camera = this.cameras[this.currentCameraIndex];
              if (camera) {
                _context9.n = 8;
                break;
              }
              throw new Error('摄像头不存在');
            case 8:
              console.log('切换摄像头:', camera);

              /**
               * =========================
               * 重新启动
               * =========================
               */
              _context9.n = 9;
              return this.startWithCamera(camera.id);
            case 9:
              this.currentCameraId = camera.id;
              this.scanning = true;

              /**
               * =========================
               * 修复 video
               * =========================
               */
              _context9.n = 10;
              return this.fixVideo();
            case 10:
              _context9.n = 12;
              break;
            case 11:
              _context9.p = 11;
              _t7 = _context9.v;
              console.error('切换摄像头失败:', _t7);
              this.handleCameraError(_t7);
            case 12:
              _context9.p = 12;
              this.starting = false;
              return _context9.f(12);
            case 13:
              return _context9.a(2);
          }
        }, _callee9, this, [[4, 6], [3, 11, 12, 13]]);
      }));
      function switchCamera() {
        return _switchCamera.apply(this, arguments);
      }
      return switchCamera;
    }(),
    // =========================================================
    // 扫码成功
    // =========================================================
    handleDecode: function () {
      var _handleDecode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(decodedText) {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!this.scanHandled) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              this.scanHandled = true;

              /**
               * 停止摄像头
               */
              _context0.n = 2;
              return this.stopScanner();
            case 2:
              /**
               * 通知父组件
               */

              this.$emit('success', decodedText);

              /**
               * 关闭
               */

              this.visible = false;
              this.$emit('input', false);
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function handleDecode(_x3) {
        return _handleDecode.apply(this, arguments);
      }
      return handleDecode;
    }(),
    // =========================================================
    // 扫描失败
    // =========================================================
    handleScanError: function handleScanError() {

      /**
       * 单帧识别失败是正常情况。
       */
    },
    // =========================================================
    // 摄像头错误
    // =========================================================
    handleCameraError: function handleCameraError(error) {
      console.error('Camera Error:', error);
      if (!error) {
        this.errorMessage = '无法启动摄像头';
        return;
      }

      /**
       * 自定义错误
       */

      if (error.message === 'HTTPS_REQUIRED') {
        this.errorMessage = '摄像头需要在 HTTPS 环境下使用';
        return;
      }
      if (error.message === 'MEDIA_NOT_SUPPORTED') {
        this.errorMessage = '当前浏览器不支持摄像头功能';
        return;
      }
      var name = error.name || '';
      switch (name) {
        case 'NotAllowedError':
          this.errorMessage = '摄像头权限被拒绝，请在 Safari 设置中允许使用摄像头';
          break;
        case 'PermissionDeniedError':
          this.errorMessage = '摄像头权限被拒绝，请允许浏览器使用摄像头';
          break;
        case 'NotFoundError':
          this.errorMessage = '没有检测到摄像头';
          break;
        case 'NotReadableError':
          this.errorMessage = '摄像头正在被其他应用或网页占用';
          break;
        case 'OverconstrainedError':
          this.errorMessage = '当前设备不支持指定摄像头';
          break;
        case 'SecurityError':
          this.errorMessage = '当前页面没有摄像头访问权限，请使用 HTTPS 访问';
          break;
        case 'AbortError':
          this.errorMessage = '摄像头启动被中断，请重新尝试';
          break;
        default:
          this.errorMessage = error.message || '摄像头启动失败，请检查浏览器权限';
      }
    },
    // =========================================================
    // 停止
    // =========================================================
    stopScanner: function () {
      var _stopScanner = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var scanner, video, _t8;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              this.scanning = false;
              if (this.scanner) {
                _context1.n = 1;
                break;
              }
              return _context1.a(2);
            case 1:
              scanner = this.scanner;
              this.scanner = null;
              _context1.p = 2;
              _context1.n = 3;
              return scanner.stop();
            case 3:
              _context1.n = 5;
              break;
            case 4:
              _context1.p = 4;
              _t8 = _context1.v;
              console.warn('停止扫码失败:', _t8);
            case 5:
              try {
                scanner.clear();
              } catch (error) {
                console.warn('清理扫码器失败:', error);
              }

              /**
               * 再处理一次 video
               */
              video = document.querySelector('#qr-reader video');
              if (video) {
                try {
                  video.pause();
                } catch (error) {
                  console.warn(error);
                }
              }
              this.currentCameraId = null;
            case 6:
              return _context1.a(2);
          }
        }, _callee1, this, [[2, 4]]);
      }));
      function stopScanner() {
        return _stopScanner.apply(this, arguments);
      }
      return stopScanner;
    }(),
    // =========================================================
    // 关闭
    // =========================================================
    close: function () {
      var _close = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              if (!this.closing) {
                _context10.n = 1;
                break;
              }
              return _context10.a(2);
            case 1:
              this.closing = true;
              _context10.p = 2;
              _context10.n = 3;
              return this.stopScanner();
            case 3:
              this.scanHandled = false;
              this.errorMessage = '';
              this.visible = false;
              this.$emit('input', false);
            case 4:
              _context10.p = 4;
              this.closing = false;
              return _context10.f(4);
            case 5:
              return _context10.a(2);
          }
        }, _callee10, this, [[2,, 4, 5]]);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }(),
    // =========================================================
    // Dialog 完全关闭
    // =========================================================
    handleDialogClosed: function () {
      var _handleDialogClosed = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return this.stopScanner();
            case 1:
              this.scanning = false;
              this.starting = false;
              this.scanHandled = false;
              this.errorMessage = '';
              this.cameras = [];
              this.currentCameraIndex = 0;
              this.currentCameraId = null;
            case 2:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function handleDialogClosed() {
        return _handleDialogClosed.apply(this, arguments);
      }
      return handleDialogClosed;
    }()
  },
  // =========================================================
  // 销毁
  // =========================================================
  beforeDestroy: function beforeDestroy() {
    this.stopScanner();
  }
};